<template>
	<div class="relative scope">
		<aside class="overlay updating">
			<i class="fa fa-spinner fa-spin"></i>
		</aside>

		<section>
			<div class="row rigid plan-cards relative">
				<div v-for="(plan, index) in planList" :key="index" class="plan-card">
					<header class="row separated">
						<h2 class="plan-title rigid placeholder"></h2>
					</header>
					<h3 class="placeholder"></h3>
				</div>
			</div>
		</section>

		<section>
			<h3 class="plan-title rigid placeholder"></h3>
			<div class="row rigid plan-cards relative">
				<div v-for="(plan, index) in packageList" :key="index" class="plan-card">
					<header class="row separated">
						<h2 class="plan-title rigid placeholder"></h2>
					</header>
				</div>
			</div>
		</section>

		<section class="column">
			<h3 class="plan-title rigid placeholder"></h3>
			<ul class="plan-features row separated-extra">
				<div class="column flexible separated">
					<li class="bullet placeholder">
						<div class="bullet-margin"><i class="fas fa-check"></i></div>
						<div class="bullet-content">
							<ul class="plan-features placeholder">
								<li></li>
								<li></li>
							</ul>
						</div>
					</li>
					<li class="bullet placeholder">
						<div class="bullet-margin"><i class="fas fa-check"></i></div>
						<div class="bullet-content">
							<ul class="plan-features placeholder">
								<li></li>
								<li></li>
							</ul>
						</div>
					</li>
					<li class="bullet placeholder">
						<div class="bullet-margin"><i class="fas fa-check"></i></div>
						<div class="bullet-content">
							<ul class="plan-features placeholder">
								<li></li>
								<li></li>
							</ul>
						</div>
					</li>
				</div>
				<div class="column flexible separated">
					<li class="bullet placeholder">
						<div class="bullet-margin"><i class="fas fa-check"></i></div>
						<div class="bullet-content">
							<ul class="plan-features placeholder">
								<li></li>
								<li></li>
							</ul>
						</div>
					</li>
					<li class="bullet placeholder">
						<div class="bullet-margin"><i class="fas fa-check"></i></div>
						<div class="bullet-content">
							<ul class="plan-features placeholder">
								<li></li>
								<li></li>
							</ul>
						</div>
					</li>
					<li class="bullet placeholder">
						<div class="bullet-margin"><i class="fas fa-check"></i></div>
						<div class="bullet-content">
							<ul class="plan-features placeholder">
								<li></li>
								<li></li>
							</ul>
						</div>
					</li>
				</div>
				
			</ul>
		</section>

	</div>
</template>

<script>
export default {
	name: 'ScopeSubPlaceholder',
	data(){
		return {
			planList: [1,2,3],
			packageList: [1,2,3,4]
		};
	},
};

</script>

<style scoped>
.overlay {
	width: 1.5em;
	height: 1.5em;
	line-height: 1.5em;
}
h2.placeholder {
	background-color: #ddd;
	width: 50%;
	height: 1em;
	margin-bottom: 1.5em;
}
.dark h2.placeholder {
	background-color: #666;
}
h3.placeholder {
	background-color: #ddd;
	width: 200px;
	height: 1em;
	margin-bottom: 1em;
}
.plan-card h3.placeholder {
	background-color: #eee;
	width: 40%;
	height: 1em;
	margin: 0;
}
.dark .plan-card h3.placeholder,
.dark h3.placeholder {
	background-color: #444;
}
.plan-features li .bullet-margin {
    width: 1.5rem;
    text-align: left;
}
.plan-features {
	margin: 0;
}
.plan-features.placeholder li {
	background-color: #f2f2f2;
	width: 100%;
	height: 1em;
}
.dark .plan-features.placeholder li {
	background-color: #333;
	width: 100%;
	height: 1em;
}
.plan-features li {
    line-height: 1.4rem;
    margin-bottom: .5rem;
}
section {
	margin-bottom: 2rem;
}
.placeholder i {
	color: #ddd;
}
.dark .placeholder i {
	color: #2a2a2a;
} 
</style>



// WEBPACK FOOTER //
// ./src/components/ScopeSubPlaceholder.vue